<template>
  <Teleport to="body">
    <div class="bottom-modal" :class="{active:cActive}">
      <div class="body shadow-lg">
        <Container class="d-flex flex-column">
          <div class="align-self-center">

            <template v-if="cIsUser">

              <template v-if="errorsCount">
                <h4>Обратите внимание:</h4>
                <ul class="errorlist">
                  <li v-for="(title,alias) in errors" :key="alias">
                    {{ title }}
                  </li>
                </ul>
              </template>

              <template v-if="!errorsCount && currentsumm >= 0 && currentsumm <= cUserBalance">
                <div class="everything" v-if="this.everything">
                  <div>Остальные места в солевой комнате свободны. Вы можете забронировать комнату полностью.</div>
                  <div class="text-center">
                    <button @click="autoselect" class="btn btn-secondary btn-sm btn-smaller mt-1 mt-md-2">
                      Выделить все места
                    </button>
                  </div>
                </div>
                <div class="sale-text">
                  Ваша персональная скидка {{ cUserSale }}%. <span
                    class="dinamic-block">Вы экономите: {{ numberFormat(salesumm) }} ₽</span>
                </div>
                <div class="text-center mt-1 mt-md-3">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="addBooking" :disabled="btnDisabled"
                          class="btn btn-primary btn-sm btn-smaller mt-1 mt-md-0">
                    Забронировать за
                    {{ numberFormat(currentsumm) }} ₽
                  </button>
                  <button @click="resetSelection" class="ms-1 mt-1 mt-md-0 btn btn-secondary btn-sm btn-smaller">
                    Cбросить
                  </button>
                </div>
              </template>

              <template v-if="!errorsCount && currentCancelSumm >= 0">
                <h4>Отменить выбранные брони?</h4>
                <div>
                  На ваш счет вернется: <span
                    class="fw-bold text-primary">{{ numberFormat(currentCancelSumm) }} ₽</span>
                </div>
                <div v-show="retentionSumm">
                  Будет удержано: <span class="fw-bold text-primary">{{ numberFormat(retentionSumm) }} ₽</span>
                </div>
                <div class="text-center mt-3">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="cancelBooking" :disabled="btnDisabled" class="btn btn-secondary btn-sm btn-smaller">
                    Отменить
                    брони
                  </button>
                  <button @click="resetSelection" class="ms-3 btn btn-secondary btn-sm btn-smaller">Cбросить</button>
                </div>
              </template>

              <template v-if="!errorsCount && currentsumm > cUserBalance">
                <h4>Недостаточно средств на балансе</h4>
                <div class="small mb-2">Выбрано броней на сумму: <span
                    class="fw-bold text-primary">{{ numberFormat(currentsumm) }} ₽</span></div>
                <div class="small mt-1">Сумма пополнения:</div>

                <div class="input-group">
                  <input type="number" v-model="addBalanceSummInput" @keyup="onUserInput"  @change="onUserInput" class="form-control d-inline"/>
                  <span class="input-group-text px-3">₽</span>
                </div>
                <div class="akcent mt-1">Комиссия сервиса: {{ $store.state.commission }}% Минимальный платеж: 1 ₽</div>
                <div class="text-center mt-2">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="confirmModalMessage" class="btn btn-primary btn-sm btn-smaller"
                          :disabled="addBalanceSumm <= 0 || btnDisabled">Пополнить на {{ numberFormat(addBalanceSumm) }}
                    ₽
                  </button>
                  <button :disabled="btnDisabled" @click="resetSelection" class="ms-3 btn btn-secondary btn-sm btn-smaller">Cбросить</button>
                </div>
              </template>

            </template>

            <template v-if="!cIsUser">
              <div class="text-center">
                <p>Для бронирования кабинетов, необходимо авторизоваться.</p>
                <a href="/login" class="btn btn-secondary btn-sm">Войти</a>
              </div>
            </template>
          </div>

        </Container>
      </div>
    </div>
  </Teleport>
  <widget-container-modal/>
</template>

<script>
import Container from "@/components/Container";
import {useToast} from "vue-toastification";

import {API} from "@/getapi";
import {container, openModal} from "jenesius-vue-modal";
import MessageModal from "@/components/BookingTable/MessageModal.vue";
import MessageModalBooking from "@/components/BookingTable/MessageModalBooking.vue";
import ConfirmModal from "@/components/BookingTable/ConfirmModal.vue";

const errorTitles = {
  '1hours': 'Минимальное время бронирования 1 час',
  'RangeHour': 'Минимальный промежуток между своими бронями - 1 час.',
  'MyRangeHour': 'Нельзя оставлять промежуток между своими бронями в 30 мин.',
  'MyOneHour': 'Минимальное время бронирования 1 час',
}
export default {
  name: "BottomModal",
  components: {WidgetContainerModal: container, Container},
  inject: [
    'percentRetention',
    'URL_PAYMENT',
    'URL_BOOKING',
    'URL_CANCEL',
    'memoryData',
    'URL_SET_MEMORY_BOOKINGS'
  ],
  data() {
    return {
      userChangeSumm: false,
      loaderShow: false,
      btnDisabled: false,
      summ: 0,
      salesumm: 0,
      currentsumm: -1,
      errors: {},
      errorsCount: 0,
      // commission: 2.9,
      addBalanceSumm: 0,
      addBalanceSummInput: 0,
      currentCancelSumm: -1,
      retentionSumm: 0,
      everything: false,
      everythingData: []
    }
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return {toast}
  },
  created() {
    // событие бронирования через кнопку в модалке
    this.$emitter.on('send_booking', () => {
      this.addBooking();
    })

  },
  mounted() {
    // this.$store.subscribe((mutation) => {
    //   // console.log(mutation.type);
    //   let watchedMutations = ['selector/deleteError','selector/selectNewCellCabinet','selector/selectMyCellCabinet','selector/setError'];
    //   if (watchedMutations.includes(mutation.type)) {
    //     console.log('selector изменился:', mutation.type);
    //     this.cActiveCheck()
    //   }
    // });
    // console.log('this.currentsumm', this.currentsumm)
    // console.log('this.cUserBalance', this.cUserBalance)
    // показ модалки подтверждения бронирования после оплаты
    if (!this.errorsCount && this.currentsumm > 0 && this.currentsumm <= this.cUserBalance && this.$store.state.memoryData && this.$store.state.memoryData != null && this.$store.state.memoryData != 'false') {
      openModal(MessageModalBooking);
    }
  },
  computed: {
    cUserBalance: function () {
      return this.cIsUser ? Number(this.$store.state.user.userBalance) : 0;
    },
    cUserSale: function () {
      let officeId = this.$store.state.selector.currentOfficeId
      if (this.cIsUser) {
        if (officeId in this.$store.state.user.userSales) {
          return Number(this.$store.state.user.userSales[officeId])
        } else {
          return Number(this.$store.state.user.userSale);
        }
      }
      return 0;
      // return this.cIsUser ? Number(this.$store.state.user.userSale) : 0;
    },
    cIsUser: function () {
      return this.$store.state.user !== false ? true : false;
    },
    getCabinetsInfo: function () {
      let officeId = this.$store.state.selector.currentOfficeId
      return 'cabinetsInfo' in this.$store.state.cabinet.data ? this.$store.state.cabinet.data.cabinetsInfo[officeId] : false;
    },

    cActive: function () {
      // console.log('cActive');
      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length
          , sizeMy = Object.keys(store.my).length
          , sizeErrorNew = Object.keys(store.error.new).length
          , sizeErrorMy = Object.keys(store.error.my).length
          , tmpN = {}
          , tmpM = {}
      if (sizeErrorNew) {
        for (var keyN in store.error.new) {
          tmpN[store.error.new[keyN]] = errorTitles[store.error.new[keyN]]
        }
        this.setErrors(tmpN)
      }
      if (sizeErrorMy) {
        for (var keyM in store.error.my) {
          tmpM[store.error.my[keyM]] = errorTitles[store.error.my[keyM]]
        }
        this.setErrors(tmpM)
      }
      if (!sizeErrorNew && !sizeErrorMy) {
        this.setErrors({})
      }
      let selectType2 = []
      let cabinetsType2 = this.getCabinetIdsType(2)

      if (sizeNew && !sizeErrorNew) {
        var _key
        var priceSumm = 0;


        for (_key in store.new) {
          priceSumm += store.new[_key]['price']
          // смотрим выбрано ли место в солевой комнате
          if (cabinetsType2) {
            if (cabinetsType2.indexOf(store.new[_key]['cabinetId']) >= 0) {
              selectType2.push(_key)
            }
          }
        }

        this.setSumm(priceSumm)
        this.calculateSumm()
        this.setCancelSumm(-1)
      } else {
        this.resetCalculateSumm()
      }
      // отключаем предложение выбрать все места
      // this.checkFreeBookingType2(selectType2, cabinetsType2)

      if (sizeMy && !sizeErrorMy) {
        var _keyM

        var priceCancelSumm = 0;
        var retentionSumm = 0;

        for (_keyM in store.my) {
          let item = store.my[_keyM]
          let priceFix = Number(item['price'])// цена ячейки
          let percent = priceFix / 100 * this.cUserSale;// скидка
          let cPrice = priceFix - percent;// цена ячейки за вычетом скидки
          let cRetentionSumm = 0

          // Делаем удержание если время отмены истекло
          if (item.cancelRetention) {
            cRetentionSumm = cPrice - (cPrice / 100 * this.percentRetention)
          }
          cPrice = cPrice - cRetentionSumm;
          priceCancelSumm += cPrice
          retentionSumm += cRetentionSumm
        }

        this.setCancelSumm(priceCancelSumm)
        this.setRetentionSumm(retentionSumm)
        this.resetCalculateSumm()
      }


      return sizeNew || sizeMy || sizeErrorNew || sizeErrorMy
    },

  },
  watch: {
    addBalanceSumm: function () {
      this.addBalanceSummInput = this.addBalanceSumm
    },
    cUserBalance: function () {
      this.updateTopMenuBalance()
    }
  },
  methods: {
    onUserInput() {
      // console.log("пользовательский ввод");
      this.userChangeSumm = true
      this.addBalanceSumm = this.addBalanceSummInput

    },

    autoselect() {
      let officeId = this.$store.state.selector.currentOfficeId
      this.$emitter.emit('autoselect_' + officeId, this.everythingData)
    },
    // checkFreeBookingType2(selectedType2, cabinetsType2) {
    //   // смотрим, можем ли предложить забронировать все места в солевой комнате
    //   this.everything = false;
    //   this.everythingData = []
    //   if (selectedType2.length) {
    //     // console.log(selectedType2, cabinetsType2)
    //     var selected = {}
    //     for (var i in selectedType2) {
    //       let data = selectedType2[i].split(':')
    //       selected[data[1]] = true
    //     }
    //     var selectedCount = Object.keys(selected).length
    //     if (selectedCount == 1) {
    //       // смотрим существующие брони
    //       var bookingData = this.$store.state.booking.data
    //       console.log(bookingData)
    //       var bookingsKeys = []
    //       for (var offId in bookingData) {
    //         for (var cabId in bookingData[offId]) {
    //           for (var hour in bookingData[offId][cabId]) {
    //             for (var minute in bookingData[offId][cabId][hour]) {
    //               bookingsKeys.push(offId + ":" + cabId + ":" + hour + ":" + minute)
    //             }
    //           }
    //         }
    //       }
    //       this.everything = true;
    //
    //         for (var cabT2i in cabinetsType2) {
    //           var cabIdt2 = cabinetsType2[cabT2i]
    //           for (var selType2i in selectedType2) {
    //             var arrType = selectedType2[selType2i].split(":");
    //             let kkey = arrType[0] + ":" + cabIdt2 + ":" + arrType[2] + ":" + arrType[3]
    //             if (bookingsKeys.indexOf(kkey) >= 0) {
    //               this.everything = false;
    //               break;
    //             } else if (cabIdt2 != arrType[1]) {
    //               this.everythingData.push(kkey)
    //             }
    //           }
    //         }
    //     }
    //   }
    //   return this.everything;
    // },
    getCabinetIdsType(type = 2) {
      let ids = [];
      let cabinetsInfo = this.getCabinetsInfo;
      if (cabinetsInfo) {
        for (var id in cabinetsInfo) {
          if (cabinetsInfo[id]['type'] == type) {
            ids.push(Number(id))
          }
        }
      }
      return ids
    },
    numberFormat(number) {
      return new Intl.NumberFormat("ru", {minimumFractionDigits: 2}).format(number).replace(',', '.');
    },
    updateTopMenuBalance() {
      const elem = document.querySelector('#top-balance')
      if (elem) {
        elem.innerHTML = this.numberFormat(this.cUserBalance)
      }
    },
    setSumm(priceSumm) {
      this.summ = priceSumm
    },
    setCancelSumm(cancelSumm) {
      this.currentCancelSumm = cancelSumm
    },
    setRetentionSumm(retentionSumm) {
      this.retentionSumm = retentionSumm
    },
    roundUpIfNotInteger(number) {
      /*
      Функция roundUpIfNotInteger сначала проверяет, является ли число целым с помощью Number.isInteger().
       Если число не целое, оно округляется в большую сторону с помощью Math.ceil().
        В противном случае возвращается само число.
      * */
      if (!Number.isInteger(number)) {
        return Math.ceil(number);
      }
      return number;
    },
    calculateSumm() {
      // console.log('calculateSumm')
      let percent = this.summ / 100 * this.cUserSale;
      this.salesumm = this.summ - (this.summ - percent);
      this.currentsumm = this.summ - percent;

      if (this.currentsumm > this.cUserBalance) {
        let allSumm = Number((this.currentsumm - this.cUserBalance).toFixed(2));
        if (this.userChangeSumm == false){
          this.addBalanceSumm = allSumm;
        }else{
          this.userChangeSumm = false
        }


        if (this.addBalanceSumm > 0 && this.addBalanceSumm < 1) {
          this.addBalanceSumm = 1.00;
        }
        this.addBalanceSumm = this.roundUpIfNotInteger(this.addBalanceSumm);
      }
    },
    resetCalculateSumm() {
      this.setSumm(0)
      this.salesumm = 0
      this.currentsumm = -1
      this.addBalanceSumm = 0
    },
    setErrors(d) {
      this.errorsCount = Object.keys(d).length
      this.errors = d
    },
    // generate UUID
    // todo это должнен предоставлять платежный провайдер, пока для теста пойдет
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    cancelBooking() {
      // URL_BOOKING
      this.btnDisabled = true
      this.loaderShow = true
      let
          store = this.$store.state.selector
          , sizeMy = Object.keys(store.my).length

      if (sizeMy) {
        console.log(store.my)
        let ids = []
        for (let key in store.my) {
          if (typeof store.my[key]['bookingParam']['id'] !== 'undefined') {
            ids.push(store.my[key]['bookingParam']['id'])
          }
        }
        console.log(ids)


        API.get(this.URL_CANCEL, {
          cancelIds: ids
        }).then(({data}) => {
          console.log(data)
          if (data.isOk) {

            this.toast.info("Отмена бронирования прошло успешно.");
            this.$store.dispatch('selector/resetSelector')
            this.$emitter.emit('bookingDone')

          } else {
            this.toast.error('Ошибка отмены бронирования.');
            console.error("Error:", data.errors)
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
      } else {
        this.toast.error('Ошибка бронирования.[нет данных]');
      }
    },
    resetSelection() {
      this.$emitter.emit('resetMemoryDataSelected')
      this.$store.dispatch('selector/resetSelector')
    },
    openModalMessage(message, title, error = false) {
      const props = {
        message: message,
        title: title,
        error: error
      };
      openModal(MessageModal, props)
    },
    confirmModalMessage() {
      const props = {
        message: 'До оплаты выбранные слоты блокируются на 10 минут и остаются за Вами. По истечении времени, слоты будут свободны для бронирования другими участниками.',
        title: 'Внимание!',
        error: false
      };
      this.$emitter.on('autoAddBooking', () => {
        this.addBalance();
      })
      openModal(ConfirmModal, props)
    },
    addBooking() {

      // URL_BOOKING
      // console.log('URL_BOOKING')
      this.btnDisabled = true
      this.loaderShow = true
      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length

      if (sizeNew) {
        console.log(store.new)

        let bookings = Object.assign({}, store.new)
        for (let key in bookings) {
          bookings[key]['date'] = this.$store.state.date
        }
        console.log(bookings)

        API.get(this.URL_BOOKING, {
          bookings: bookings
        }).then(({data}) => {
          // console.log(data)
          if (data.isOk) {
            // this.loaderShow = false
            // this.btnDisabled = false
            if ('message' in data && (data.message != '' && !!data.message)) {
              var msg = data.message.replace(/(?:\r\n|\r|\n)/g, '<br>');
              this.toast.info("Бронирование прошло успешно.");
              this.openModalMessage(msg, 'Бронирование прошло успешно!')

            } else {
              this.toast.info("Бронирование прошло успешно.");
              // this.openModalMessage('Бронирование прошло успешно!','')
            }
            // this.toast.info("Бронирование прошло успешно.");
            this.$store.dispatch('selector/resetSelector')
            this.$emitter.emit('resetMemoryDataSelected')
            this.$emitter.emit('bookingDone')


          } else {
            var errorMessage = data.errors.message
            var errorCode = data.errors.code
            this.openModalMessage('Code:' + errorCode + '<br> Message: ' + errorMessage, 'Ошибка бронирования.', true)
            // this.toast.error('Ошибка бронирования.');
            console.error("Error:", data.errors)
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
        // this.loaderShow = false
        // this.btnDisabled = false
      } else {
        this.toast.error('Ошибка бронирования.[нет данных]');
      }

    },
    addBalance() {
      this.$emitter.off('autoAddBooking')
      this.btnDisabled = true
      this.loaderShow = true
      /**
       * Создадим событие перехода на пополнение баланса
       */
      this.$emitter.emit('addBalanceClick')


      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length

      if (sizeNew) {
        let bookings = Object.assign({}, store.new)
        for (let key in bookings) {
          bookings[key]['date'] = this.$store.state.date
        }
        // console.log(bookings)


        // let officeSelectData = Object.keys(this.$store.state.selector.new);
        // console.log(officeSelectData)
        API.get(this.URL_SET_MEMORY_BOOKINGS, {
          bookings: bookings
        }).then(({data}) => {
          // console.log(data)
          if (data.isOK) {
            window.location.href = "/add-balance?sum=" + this.addBalanceSumm + '&booking=1';
          } else {
            // this.toast.error('[535] Ошибка отправки данных о бронировании.');
            this.toast.error('Ошибка: ' + data.errors.message);
            console.error("Ошибка:", data.errors.message)
            this.loaderShow = false
            this.btnDisabled = false
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
      }

      // console.log('Пополняем баланс на сумму: ', this.addBalanceSumm)
      // window.location.href = "/add-balance?sum=" + this.addBalanceSumm+'&booking=1';


      // let _this = this

      // API.get(this.URL_PAYMENT, {
      //   summ: this.addBalanceSumm,
      //   paymentUuid: this.uuidv4()
      // }).then(({data}) => {
      //   if (data.isOk) {
      //     this.loaderShow = false
      //     this.btnDisabled = false
      //     this.toast.info("Баланс пополнен на: " + this.numberFormat(this.addBalanceSumm) + ' ₽');
      //     this.$store.dispatch('updateUserBalance', this.addBalanceSumm + this.cUserBalance)
      //   } else {
      //     this.toast.error('Ошибка пополнения баланса.');
      //     console.error("Error:", data.errors)
      //   }
      // }).catch((err) => {
      //   API.catch(err)
      // }).finally(() => {
      //   this.loaderShow = false
      //   this.btnDisabled = false
      // })
    },
  }
}
</script>

<style scoped>

.everything {
  text-align: center;
  position: relative;
  top: -50px;
  margin-bottom: -40px;
  background: #fff;
  border-radius: 5px;
  font-size: .9rem;
  padding: 0.5rem 0.9rem;
  box-shadow: 1px 1px 16px 0px #c3c3c3;
}

.everything .btn-smaller {
  font-size: .9em;
  padding: 0.1rem 0.5rem;
  border-radius: 20px;
}

.btn-smaller {
  padding: 0.2rem 0.7rem;
  border-radius: 20px;
}

.akcent {
  font-size: .9rem;
  display: block;
  margin: 0 auto;
  color: #db971a;

}

.bottom-modal {
  position: fixed;
  container-name: bottom-modal-cnt;
  container-type: inline-size;
  width: 100%;
  z-index: 1100;
  left: 0;
  bottom: -250px;
  opacity: .5;
  /* display: none; */
  border-top: 1px solid #ebdabe;
  transition: all ease .5s;
  font-size: 0.9rem;
}

.bottom-modal.active {
  position: fixed;
  bottom: 0;
  opacity: 1;
}

.body {
  background: #FFF8DA;
  padding: 2rem 2rem;
  border-radius: 10px 10px 0 0;
}

.errorlist {
  margin: 0;
  padding: 0.5rem 3rem;
  background: #ffdbac;
  color: #905d1a;
  border: 1px solid #e5b678;
  border-radius: 10px;
}

.errorlist li {
  list-style: none;
}

.sale-text {
  text-align: center;
}

@container bottom-modal-cnt (max-width: 600px) {
  .body {
    padding: 1rem 1rem;
  }

  h4 {
    font-size: 1.1rem;
  }

  .errorlist {
    font-size: .85rem;
    padding: 3cqw 6cqw;
  }

  .sale-text {
    text-align: center;
    font-size: 0.85rem;
  }

  button {
    font-size: 0.75rem;
    padding: 0.3rem 0.7rem;
  }

  .dinamic-block {
    display: block;
  }

  .everything {
    font-size: .8rem;
  }
}
</style>